import * as React from "react";
const SvgDeviceUnknown = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m12.188 1.639-.003 3.398-.003 3.4-4.088.004-4.09.002L8.846 15.4l4.84 6.957.002-3.398.002-3.396 4.09-.004 4.09-.002-4.84-6.96zm1.507 4.797 2.65 3.81 2.653 3.813-3.408.003-3.408.002-.002 1.749-.002 1.748-2.643-3.8C8.081 11.672 6.89 9.957 6.887 9.95c-.004-.01.566-.013 3.398-.013h3.404l.002-1.75z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDeviceUnknown;
